/* eslint-disable */
import {
    getToken,
    getAdminId,
} from "../../../utils/auth";
// import { $NOT_NETWORK } from '../../utils/errorCode'
import { Message } from "element-ui";
import axios from 'axios'
import https from "../../../utils/http";
let http = https.https
const state = {
};

// getters
const getters = {
};

// mutations
const mutations = {
    
};

// actions
const actions = {
    // 用户列表显示
    UserListShow({ commit }, data) {
        return axios.post(http + '/org/user/show', data).then(res => {
            return res.data
        })
    },
    // 保存用户
    SaveUser({ commit }, data) {
        return axios.post(http + '/org/user/add', data).then(res => {
            return res.data
        })
    },
    // 删除用户
    DelUser({ commit }, data) {
        return axios.post(http + '/org/user/delete', data).then(res => {
            return res.data
        })
    },
    // 门禁列表显示
    AccessControlListShows ({ commit }, data) {
        return axios.post(http + '/guard/guard/authlist', data).then(res => {
            return res.data
        })
    },
    // 保存门禁权限
    SaveAccessControlAuth({ commit }, data) {
        return axios.post(http + '/guard/guard/guard_auth', data).then(res => {
            return res.data
        })
    },
    // 客户申请列表
    GetCustomerlist({ commit }, data) {
        return axios.post(http + '/org/user/show_invite', data).then(res => {
            return res.data
        })
    },
    // 客户申请操作
    opreateinvite({ commit }, data) {
        return axios.post(http + '/org/user/opreate_invite', data).then(res => {
            return res.data
        })
    }
    // 用户名登录
    // NoticeAdministrationListShow({ commit }, data) {
    //     data.ADMIN_ID = getAdminId();
    //     data.ADMIN_TOKEN = getToken();
    //     return axios.post(http + '/notice/show', data).then(res => {
    //         return res.data
    //     })
    // },
    // AddNoticeAdministration({ commit }, data) {
    //     data.ADMIN_ID = getAdminId();
    //     data.ADMIN_TOKEN = getToken();
    //     return axios.post(http + '/notice/add', data).then(res => {
    //         return res.data
    //     })
    // },
    // DeleteNoticeAdministration({ commit }, data) {
    //     data.ADMIN_ID = getAdminId();
    //     data.ADMIN_TOKEN = getToken();
    //     return axios.post(http + '/notice/delete', data).then(res => {
    //         return res.data
    //     })
    // }
};

const UserManagementModule = {
    state,
    getters,
    actions,
    mutations
}
export default UserManagementModule
